import type { IParkingLotCallResponse, IParkingLotWithOccupancyResponse } from '@/openapi-clients-generated/talk';

import { attachmentAvailable, requestAttachment, requestDial } from '@/shared/services/dialer.service';

/**
 * Retrieve a specific parked call. When the dialer can run the exact attachment RPC and this
 * allocation has an instance ID (pre-generation allocations don't — see `IParkingLotCallResponse`),
 * attach directly; otherwise fall back to dialing the slot extension, which the server resolves
 * FIFO-style (a stale row surfaces as the server's own user error).
 */
export function retrieveParkedCall(lot: Pick<IParkingLotWithOccupancyResponse, 'id'>, item: IParkingLotCallResponse) {
    if (item.parkingInstanceId && attachmentAvailable.value) {
        requestAttachment({
            kind: 'retrieve',
            callId: item.callId,
            parkingLotId: lot.id,
            parkingInstanceId: item.parkingInstanceId,
            label: item.slotExtension
        });
        return;
    }
    requestDial(item.slotExtension);
}
